<template>
    <div class="limage">
        <img class="lazyload" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" :data-src="browserSrc" :alt="alt" />
        <loader class="overlay" />
    </div>
</template>

<script>
export default {
        name: 'LazyImage',
        props: {
            src: {
                type: String,
                default: () => ""
            },
            alt: {
                type: String,
                default: () => ""
            }
        },
        computed:{
            browserSrc(){
                return Modernizr.webp ? this.src + ".webp" : this.src;
            }
        }
}
</script>
<style lang="scss">
    .limage {
        position: relative;

        .lazyload, .lazyloading {
            background: $lazy-background;
        }

        .lazyloaded  {
            background: transparent;
            ~ .loader {
                display: none;
            }
        }

        img {
            display: block;
            width: 100%;
            height: 100%;
        }

        .loader {
            position: absolute;
            display: block;
            top: 50%;
            left: 50%;
            width: 64px;
            height: 64px;
            transform: translate(-50%, -50%);
            z-index: 1;

           div {
                display: block;
                position: absolute;
                width: 51px;
                height: 51px;
                margin: 6px;
                border: 6px solid #fff;
                border-radius: 50%;
                animation: loader 1.2s ease-in-out infinite;
                border-color: $lazy-color transparent transparent transparent;
            
                &:nth-child(1) {
                    animation-delay: -0.45s;
                }
                &:nth-child(2) {
                    animation-delay: -0.3s;
                }
                &:nth-child(3) {
                    animation-delay: -0.15s;
                }
            }

            @keyframes loader {
                0% {
                transform: rotate(0deg);
                }
                100% {
                transform: rotate(360deg);
                }
            }
        }
    }
</style>
